// extracted by mini-css-extract-plugin
export default {"container":"D1-z","heading":"E1-z","links":"F1-z","copy":"G1-z","subCopy":"H1-z","linksLeft":"I1-z","linksCenter":"J1-z","linksRight":"K1-z","link":"L1-z","onlyLink":"M1-z"};